import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import H1Header from "../components/H1Header";

const NotFoundPage = () => (
  <Layout>
    {/* Hero */}
    <Container
      className="hero"
      maxWidth="false"
      sx={{
        bgcolor: "primary.main",
        py: 8,
      }}
    >
      <Container maxWidth="md" alignItems="center">
        <H1Header>
          This page is not here. 404.
        </H1Header>
      </Container>
    </Container>

    {/* End Hero */}
  </Layout>
);

export const Head = () => <Seo title="404: Not Found" />;

export default NotFoundPage;
